import {API} from '@/api/API';
import {APIResponseCode} from '@/lib/enums';
import {APIErrorResponse} from '@/types';
import {canBeJSONParsed} from '@/utils/canBeJSONParsed';
import {AxiosError, AxiosResponse} from 'axios';
import {NavigateFunction} from 'react-router-dom';

let api: API | null = null;

/** Drops cached client so the next session gets a fresh axios stack (e.g. after refresh fails). */
export const clearStoredApiClient = () => {
    api = null;
};

export const getApi = (navigate: NavigateFunction) => {
    const storedAuth = localStorage.getItem('auth');

    if (!storedAuth || !canBeJSONParsed(storedAuth)) {
        api = null;
        navigate('/login');
        throw new Error('Need to be logged in');
    }

    if (api) return api;

    const auth = JSON.parse(storedAuth);

    api = new API(auth, navigate);

    return api;
};

export const resetApi = async () => {
    if (api) {
        try {
            await api.logout();
        } catch (error) {
            if (error instanceof AxiosError && error.response) {
                const code = (error.response as AxiosResponse<APIErrorResponse>)
                    .data.code;

                /**
                 * If it's a token invalid error, proceed with the
                 * logout anyway, otherwise throw.
                 */
                if (code !== APIResponseCode.TOKEN_INVALID) {
                    throw error;
                }
            }
        }
    }
    localStorage.removeItem('auth');
    clearStoredApiClient();
};
